module.exports =
  '_ROUND_DETAIL':
    "TITLE": 'ラウンド詳細'
    "INFO":
      'COMPETITORS': '同伴者'
    "MEMO":
      "TITLE": "メモ"
    'TOTAL':
      'OB': 'OB'
      'SAND_SAVES': 'ガードバンカー'
      'WATER_HAZARD': 'ウォーターハザード・PN'
    'PLAYERS_ANALYSIS':
      'PAR_ON': "パーオン率（％）"
      'BOGEY_ON': "ボギーオン率（％）"
      'AVG_PUTT': "ひとホールあたりの平均パット数"
      'AVG_PAR_ON_PUTT_CNT': "パーオン時の平均パット数"
      'RAT_UNDER_EAGLE': "イーグル以上（％）"
      'RAT_BIRDIE': "パーディ（％）"
      'RAT_PAR': "パー（％）"
      'RAT_BOGEY': "ボギー（％）"
      'RAT_DBOGEY': "ダブルボギー（％）"
      'RAT_OVER_TBOGEY': "トリプルボギー以上（％）"
      'AVG_SHOT_PAR3': "平均ストローク[Par 3]"
      'AVG_SHOT_PAR4': "平均ストローク[Par 4]"
      'AVG_SHOT_PAR5': "平均ストローク[Par 5]"
      'RAT_RECOVERY': "リカバリー"
      'RAT_SAND_SAVE': "ガードバンカー"
      'RAT_FAIRWAY_CENTER': 'フェアウェイキープ率（％)'
      'RAT_FAIRWAY_LEFT': '左ミス（％)'
      'RAT_FAIRWAY_RIGHT': '右ミス（％)'




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/round-detail/i18n/ja.coffee